import React from 'react'
import { useRecoilState } from 'recoil'
import { Box, Button, Text, ModalBase } from '@/presentation/components'
import { useTheme } from '@/presentation/hooks'
import { isOpenDeleteConfirmationState } from '@/presentation/pages/Cartao/components'
import { styles } from './styles'

type ModalDeleteConfirmationProps = {
  onDelete: () => void
}

export const ModalDeleteConfirmation: React.FC<ModalDeleteConfirmationProps> = ({ onDelete }) => {
  const theme = useTheme()
  const [isOpen, setOpen] = useRecoilState(isOpenDeleteConfirmationState)

  const handleClose = (): void => {
    setOpen(false)
  }

  const handleDelete = (): void => {
    onDelete()
    setOpen(false)
  }

  return (
    <ModalBase visible={isOpen} onClose={handleClose}>
      <Box style={styles.container}>
        <Text variant="subtitle1" style={{ fontWeight: '500' }}>Deseja realmente excluir os dados do cartão do seu cadastro?</Text>

        <Box style={styles.buttonArea}>
          <Button
            color={theme.colors.shadow}
            tintColor={theme.colors.white}
            variant="text"
            title="CANCELAR"
            testID='cartao-cancelar-exclusao'
            onPress={handleClose}
          />
          <Button
            title="EXCLUIR"
            testID='cartao-excluir'
            onPress={handleDelete}
            tintColor={theme.colors.white}
            color={theme.colors.error}
          />
        </Box>
      </Box>
    </ModalBase>
  )
}
